// no-paste.directive.ts
import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[noPaste]'
})
export class NoPasteDirective {

  @HostListener('paste', ['$event'])
  onPaste(e: Event) {  
    e.preventDefault();
  }

  @HostListener('contextmenu', ['$event'])
  onContextMenu(e: Event) {
    
    e.preventDefault();
  }

  @HostListener('drop', ['$event'])
  onDrop(e: Event) {

    e.preventDefault();
  }
}